// 此方法专门用于token的操作
const KEY = 'hmmj-ELement-90-token'

// 保存token到本地存储
export const setToken = (token) => {
  localStorage.setItem(KEY, token)
}

// 从本地存储获取token
export const getToken = () => {
  return localStorage.getItem(KEY)
}

// 从本地存储删除token
export const removeToken = () => {
  localStorage.removeItem(KEY)
  // 不能使用clear方法 它会清除所有的本地存储
}

// 新增：检查token是否存在
export const hasToken = () => {
  return !!getToken()
}
